import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BoostOptions } from "highcharts";

export interface AdvertisingState {
  aggregation_type: string;
  grouping_type: string;
  time_frames: string;
  isChart: boolean;
  filter_fields: string[];
  filterValue: string;
  noOfRecords: string;
}

export const initialState: AdvertisingState = {
  aggregation_type: "week",
  grouping_type: "asin",
  noOfRecords: "5",
  time_frames: "6",
  isChart: false,
  filter_fields: [],
  filterValue: "",
};

export const advertisingSlice = createSlice({
  name: "advertising",
  initialState,
  reducers: {
    changeAdvertisingTimeFrames: (
      state: AdvertisingState,
      action: PayloadAction<string>
    ) => {
      state.time_frames = action.payload;
    },
    changeAdvertisingAggregationType: (
      state: AdvertisingState,
      action: PayloadAction<string>
    ) => {
      state.aggregation_type = action.payload;
    },
    changeAdvertisingGroupingType: (
      state: AdvertisingState,
      action: PayloadAction<string>
    ) => {
      state.grouping_type = action.payload;
    },
    changeAdvertisingChartType: (
      state: AdvertisingState,
      action: PayloadAction<boolean>
    ) => {
      state.isChart = action.payload;
    },
    changeAdvertisingTotalRecords: (
      state: AdvertisingState,
      action: PayloadAction<string>
    ) => {
      state.noOfRecords = action.payload;
    },
    addFilters: (state: AdvertisingState, action: PayloadAction<string[]>) => {
      state.filter_fields = action.payload;
      state.filterValue = action.payload[0];
    },
    changeFilterValue: (
      state: AdvertisingState,
      action: PayloadAction<string>
    ) => {
      state.filterValue = action.payload;
    },
  },
});

export const {
  changeAdvertisingAggregationType,
  changeAdvertisingTimeFrames,
  changeAdvertisingGroupingType,
  changeAdvertisingChartType,
  changeAdvertisingTotalRecords,
  addFilters,
  changeFilterValue,
} = advertisingSlice.actions;